<template>
  <component
    :is="computedTag"
    v-bind="computedAttributes"
    class="aj-button"
    :class="classObject"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
/**
 * Use `AjButton` to add buttons on the page
 */
export default {
  name: 'AjButton',

  props: {
    tag: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
    rel: {
      type: String,
      default: null,
    },
    to: {
      type: [String, Object],
      default: null,
      required: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    tertiary: {
      type: Boolean,
      default: false,
    },
    subtleDark: {
      type: Boolean,
      default: false,
    },
    subtleLight: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedTag () {
      if (this.to && this.tag === 'router-link') {
        return 'router-link';
      }
      if (this.href && this.tag === 'a') {
        return 'a';
      }

      return this.tag;
    },

    computedAttributes () {
      const attrs = {};

      if (this.tag === 'a') {
        if (this.href) {
          attrs.href = this.href;
        }
        if (this.target) {
          attrs.target = this.target;
        }
        if (this.rel) {
          attrs.rel = this.rel;
        }
      }

      if (this.tag === 'router-link') {
        attrs.to = this.to;
      }

      return attrs;
    },

    classObject () {
      return {
        '-small': this.small,
        '-large': this.large,
        '-wide': this.wide,
        '-primary': this.primary,
        '-secondary': this.secondary,
        '-tertiary': this.tertiary,
        '-subtleDark': this.subtleDark,
        '-subtleLight': this.subtleLight,
        '-text': this.text,
        '-link': this.link,
        '-disabled': this.disabled,
        '-loading': this.loading,
      };
    },
  },
};
</script>

<style lang="scss" src="./AjButton.scss" scoped />
